import React, { ReactNode } from "react";
import { Grid, Typography, Box } from "@mui/material";

interface NoActiveRaffleProps {
  logo?: string;
  title?: string;
  action?: ReactNode;
}

export const NoActiveRaffle = ({ logo, title = "🚫 Sin rifas activas", action }: NoActiveRaffleProps) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      sx={{
        background: "linear-gradient(135deg, #0f0f0f, #1a1a1a)",
        color: "#fff",
        textAlign: "center",
        px: 2,
        fontFamily: "Phrastic",
      }}
    >
      <Grid item xs={12} sm={10} md={6} lg={4}>
        <Box display="flex" justifyContent="center" mb={3}>
          <img
            src={logo}
            width={180}
            height={180}
            style={{
              borderRadius: 30,
              filter: "drop-shadow(0 0 10px rgba(255,255,255,0.1))",
              transition: "transform 0.3s ease",
            }}
            alt="Logo"
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </Box>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: "Phrastic", color: "white" }}>
          {title}
        </Typography>
        {action}
      </Grid>
    </Grid>
  );
};
